"use client";

import { Bar, BarChart, CartesianGrid, XAxis } from "recharts";
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "../../component/ui/Chart";
import { useTheme } from "../../contexts/ThemeContext";

const chartData = [
    { month: "January", item1: 186, item2: 80 },
    { month: "February", item1: 305, item2: 200 },
    { month: "March", item1: 237, item2: 120 },
    { month: "April", item1: 73, item2: 190 },
    { month: "May", item1: 209, item2: 130 },
    { month: "June", item1: 214, item2: 140 },
];

const chartConfig = {
    item1: {
        label: "Item1",
        color: "#006A66",
    },
    item2: {
        label: "Item2",
        color: "#C6D92D",
    },
} satisfies ChartConfig;

export function ThermalCapacityChart() {
    const { currentTheme } = useTheme();

    return (
        <ChartContainer config={chartConfig} className="min-h-[150px] w-full">
            <BarChart accessibilityLayer data={chartData}>
                <CartesianGrid
                    vertical={false}
                    stroke={currentTheme === "dark" ? "#7A8690" : "#C6C5C5"}
                    strokeWidth={0.5}
                />
                <XAxis
                    dataKey="month"
                    tickLine={false}
                    tickMargin={10}
                    axisLine={false}
                    tickFormatter={(value) => value.slice(0, 3)}
                    stroke={currentTheme === "dark" ? "#CEE0EF" : "#535353"}
                />
                <ChartTooltip content={<ChartTooltipContent />} />
                <Bar dataKey="item1" fill="var(--color-item1)" radius={4} />
                <Bar dataKey="item2" fill="var(--color-item2)" radius={4} />
            </BarChart>
        </ChartContainer>
    );
}
